
  import { mapState, mapGetters } from 'vuex'
  import bankAccount from '~/mixins/common/bank-account'
  import finance from '~/mixins/common/pages/finance'
  import payment from '~/mixins/common/payment'
  import staticAmount from '~/static/json/amount.json'
  export default {
    mixins: [payment, finance, bankAccount],
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        steppers: 1,
        valid: true,
        form: { amount: null },
        formData: {
          paymentType: null,
          third_party_account_uuid: null
        },
        selectedBankId: null,
        pleaseSelectedBankId: false,
        depositAmount: '',
        amount: '',
        createDepositLoading: false,
        remainingTime: '--:--',
        countingDownInterval: null,
        depositOption: '',
        depositChannelList: [],
        channelList: {},
        loadingProvider: false,
        currentPage: 0,
        itemsPerPage: 4,
        currentChannelPage: 0,
        channelItemsPerPage: 6
      }
    },
    computed: {
      ...mapState({
        thirdPartyPayments: state => state.themes.deposit.thirdPartyPayments,
        player: state => state.player.player,
        checkExist: state => state.themes.deposit.checkExist
      }),
      ...mapGetters({
        promotionGetter: 'cms/promotion',
        bankAccount: 'themes/player-bank/bankAccount'
      }),
      promotion() {
        return this.promotionGetter(this.$config.THEME)
      },
      selectAmount() {
        const res = staticAmount.find(value => value.currentcy === this.$cookie.get('currency'))
        return res.amount
      },
      totalPages() {
        const allOptions = this.thirdPartyPayments
        return Math.ceil(allOptions.length / this.itemsPerPage)
      },
      totalChannelPages() {
        const allChannels = this.depositChannelList
        return Math.ceil(allChannels.length / this.channelItemsPerPage)
      },
      paginatedPayments() {
        const startIndex = this.currentPage * this.itemsPerPage
        const endIndex = startIndex + this.itemsPerPage
        return this.thirdPartyPayments.slice(startIndex, endIndex)
      },
      paginatedChannels() {
        const allChannels = this.depositChannelList
        const startIndex = this.currentChannelPage * this.channelItemsPerPage
        const endIndex = startIndex + this.channelItemsPerPage
        return allChannels.slice(startIndex, endIndex)
      },
      disabledNextButton() {
        if (!this.depositOption) return true
        if (!this.formData?.third_party_account_uuid) return true
        if (!this.selectedBankId) return true
        return false
      },
      amountErrorMessage() {
        if (!this.depositAmount) return null

        const minDeposit = parseFloat(this.channelList?.min_deposit || 50)
        const maxDeposit = parseFloat(this.channelList?.max_deposit || 1000)
        const currency = this.player?.currency || ''

        const numericValue = parseFloat(this.depositAmount.replaceAll(',', ''))

        // don't allow decimal values; BZ requirements

        if (this.depositAmount?.toString()?.includes('.')) {
          return this.tr(this.FRONTEND_ERROR_CODES.decimalIsNotAllowed)
        }

        if (numericValue < minDeposit) {
          return `${this.tr(
            this.FRONTEND_ERROR_CODES.amountMustBeGreatThan
          )} ${this.formatCurrencyJS(minDeposit)} ${currency}`
        }

        if (numericValue > maxDeposit) {
          return `${this.tr(
            this.FRONTEND_ERROR_CODES.amountMustBeLessThan
          )} ${this.formatCurrencyJS(maxDeposit)} ${currency}`
        }

        if (!this.decimalRule(this.depositAmount)) {
          return this.tr(this.FRONTEND_ERROR_CODES.decimalIsTwoDigit)
        }

        return null
      }
    },
    watch: {
      thirdPartyPayments(value) {
        if (value?.length > 0) {
          this.depositOption = value[0].id
          this.depositChannelList = value[0]?.channels
        }
      },
      depositOption(value) {
        if (value) {
          const channelList = this.thirdPartyPayments.find(el => el.id === value)
          this.depositChannelList =
            channelList?.channels?.map(channel => ({
              ...channel,
              tp_id: channelList.tp_id
            })) || []
        }
      },
      depositChannelList(value) {
        if (value?.length > 0) {
          this.formData.third_party_account_uuid = value[0].id
          const chList = this.depositChannelList.find(el => el.id === value[0]?.id)
          this.channelList = chList ?? {}
        }
      },
      'formData.third_party_account_uuid'(value) {
        if (value) {
          const chList = this.depositChannelList.find(el => el.id === value)
          this.channelList = chList ?? {}
        }
      },
      checkExist(value) {
        if (value.is_exist) {
          this.onlineBankCheckIsExist(value)
        } else {
          this.steppers = 1
        }
      }
    },
    created() {
      this.showDisableAccount = true
    },
    mounted() {
      this.thirdPartyDepositChannel = new BroadcastChannel('third-party-deposit')
      this.fetchingProviders()
      if (this.checkExist?.is_exist) {
        this.onlineBankCheckIsExist(this.checkExist)
      }
    },
    beforeDestroy() {
      if (this.thirdPartyDepositChannel) {
        this.thirdPartyDepositChannel.close()
      }
    },
    methods: {
      async fetchingProviders() {
        if (this.thirdPartyPayments.length !== 0) {
          if (this.thirdPartyPayments?.length > 0) {
            this.depositOption = this.thirdPartyPayments[0].id
          }
          return
        }
        this.loadingProvider = true
        await this.$store.dispatch('themes/deposit/getThirdPartyPayments')
        this.loadingProvider = false
      },
      timeFormat(value) {
        return ('0' + parseInt(value || '00')).slice(-2)
      },
      async formStep() {
        if (this.$refs.form.validate()) {
          // Track Events if not first deposit
          await this.trackThirdPartyDepositEvent(this.checkExist.sequence, this.formData.amount)

          if (this.pleaseSelectedBankId) return

          const form = {
            amount: this.formData.amount,
            third_party_account_uuid: this.formData.third_party_account_uuid,
            player_bank_account_id: this.selectedBankId
          }
          this.createDepositLoading = true
          const response = await this.$store.dispatch('themes/deposit/openDepositThirdParty', form)
          if (response) {
            this.thirdPartyDepositChannel.onmessage = event => {
              this.createDepositLoading = false
              if (event.data.success) {
                this.steppers = 2
                this.$emit('enableDisabledPaymentMethod', {
                  ...response,
                  is_exist: true
                })
              } else if (event?.data?.error_code) {
                this.$toast.error(
                  parseFloat(this.tr(event.data.error_code)) === event.data.error_code
                    ? event.data.message
                    : this.tr(event.data.error_code)
                )
              }
            }
          }
        }
      },
      onlineBankCheckIsExist(data) {
        if (data.is_exist) {
          this.steppers = 2
        }
      },
      onInputAmount(amount, key) {
        if (isNaN(amount?.toString()?.replace(/,/g, ''))) {
          this.formData[key] = '0'
          return
        }
        if (key === 'amount') {
          this.depositAmount = this.customFormatNumber(amount?.toString()?.replace(/,/g, ''))
          this.formData[key] = this.depositAmount?.toString()?.replace(/,/g, '')
        }
      },
      formatNumber(number) {
        return this.customFormatNumber(number?.toString()?.replace(/,/g, ''))
      },
      onSelectAmount(amount) {
        this.amount = amount?.toString()
        this.depositAmount = this.customFormatNumber(amount?.toString()?.replace(/,/g, ''))
        this.formData.amount = amount?.toString()
      },
      navigatePage(direction) {
        const newPage = this.currentPage + direction
        if (newPage >= 0 && newPage < this.totalPages) {
          this.currentPage = newPage
        }
      },
      navigateChannelPage(direction) {
        const newPage = this.currentChannelPage + direction
        if (newPage >= 0 && newPage < this.totalChannelPages) {
          this.currentChannelPage = newPage
        }
      },
      navigate() {
        this.$router.push('/payment-methods')
      }
    }
  }
